import React from 'react';
import { graphql, useFragment } from 'react-relay/hooks';
import { FileList as SonikaFileList, Panel } from '@sonika-se/ui-kit/components';
import { useApi } from '@sonika-se/ui-kit/hooks';
import useUserAttachments from '~/hooks/attachments/useUserAttachments';
export const UserAttachmentsPanel = (props) => {
    const { userRef } = props;
    const user = useFragment(graphql `
      fragment UserAttachmentsPanel_user on User {
        ...useUserAttachments_user
      }
    `, userRef);
    const { addAttachments, data, removeAttachment, uploading } = useUserAttachments(user);
    const { downloadFile } = useApi();
    return (<Panel title="Filer">
      <SonikaFileList defaultFiles={data.attachments.edges.map(({ node }) => node)} editable headerText="Släpp filer här eller klicka för att välja" onChange={(files) => {
            addAttachments(Array.from(files));
        }} onDelete={(file) => {
            removeAttachment(file);
        }} onDownload={(url, name) => {
            downloadFile(url, name)
                .then((ok) => console.log({ ok }))
                .catch((fail) => console.log({ fail }));
        }}/>
    </Panel>);
};
export default UserAttachmentsPanel;
